import styles from "../Editor.module.css";
import InputControl from "../../InputControl/InputControl";

const CourseBody = (props) => {
    const sections = props.sections;
    const courses = ["Course1","Course2","Course3","Course4","Course5","Course6","Course7","Course8","Course9","Course10"];
  return (
    <div className={styles.detail}>
      <div className={styles.column}>
        <label>List your coursework</label>
        {courses.map((course, index)=>(
          <InputControl
            placeholder={course}
            value={props.information[sections.course].points ? props.information[sections.course].points[index] : ""}
            // value={values.points ? values.points[index] : ""}
            onChange={(event) => 
              // handlePointUpdate(event.target.value, index)
              props.setInformation((prev) => ({ ...prev, 
                [sections.course]: {...prev[sections.course],
                    points: prev[sections.course].points.map((point, pointIndex) =>
                      pointIndex === index? event.target.value : point
                    )
                }
              }))
            }
          />
        ))}
      </div>
    </div>
  )
}

export default CourseBody